<template>
  <div>
    <div class="actions nowrap">
      <div v-if="item.showChip">
        <v-chip
          :color="item.chipColor"
          small
          outlined
          class="mr-2"
          @click="editItem(item)"
        >
          {{ item.load_status }}
        </v-chip>
      </div>

      <div v-if="item.canSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="searchItem(item)"
            >
              mdi-text-box-search-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Atnaujinti turto duomenis') }}
          </div>
        </v-tooltip>
      </div>
      <div v-if="item.canReload">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="reloadItem(item)"
            >
              mdi-archive-refresh-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Atnaujinti turto duomenis') }}
          </div>
        </v-tooltip>
      </div>

      <el-byla v-if="item.canDownload" :byla="item" />

      <div v-if="item.canEdit">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="editItem(item)"
            >
              mdi-pencil-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Redaguoti') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canView">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewItem(item)"
            >
              mdi-eye-check
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Peržiūrėti') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canPriskirti">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="priskirtiItem(item)"
            >
              mdi-account-arrow-left-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Priskirti sau') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canCancelPriskirti">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="cancelPriskirtiItem(item)"
            >
              mdi-account-cancel-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Atšaukti priskyrimą') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canViewArchyvas">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewArchyvasItem(item)"
            >
              mdi-eye-check
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Peržiūrėti') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canSelect">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="selectItem(item)"
            >
              mdi-account-check-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Pasirinkti') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canDuplicate">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="duplicateItem(item)"
            >
              mdi-content-duplicate
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Kurti dokumentą šio dokumento pagrindu') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canTransfer">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="transferItem(item)"
            >
              mdi-file-move-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Perduoti sandorį kitam notarui') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canDelete">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="deleteItem(item)"
            >
              mdi-delete-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Šalinti') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canRestore">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="restoreItem(item)"
            >
              mdi-restore
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Atstatyti') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canAddAtstovas">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="addAtstovas(item)"
            >
              mdi-account-plus-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Pridėti atstovą') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canEditAtstovas">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="editAtstovas(item)"
            >
              mdi-account-edit-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Redaguoti atstovą') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canViewAtstovas">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewAtstovas(item)"
            >
              mdi-account-search-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Peržiūrėti atstovą') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canDeleteAtstovas">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="deleteAtstovas(item)"
            >
              mdi-account-remove-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Šalinti atstovą') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canResend">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="resendItem(item)"
            >
              mdi-book-sync-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Pakartoti siuntimą') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.cansendKitas">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="sendKitasItem(item)"
            >
              mdi-book-plus-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Siųsti kitam') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canDvs">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="dvsItem(item)"
            >
              mdi-book-plus-outline
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Pridėti DVS duomenis') }}
          </div>
        </v-tooltip>
      </div>

      <div v-if="item.canLock">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              color="red"
              v-bind="attrs"
              v-on="on"
              @click="viewItem(item)"
            >
              mdi-lock
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ $t('Redaguoja') }}<br />
            {{ item.lockMsg }}
          </div>
        </v-tooltip>
      </div>
    </div>
    <div v-if="item.showSign">
      <v-chip
        color="red"
        small
        outlined
        class="mt-1 mb-1"
        @click="editItem(item)"
      >
        {{ $t('Laukia pasirašymo') }}
      </v-chip>
    </div>
    <div v-if="item.showConfirm">
      <v-chip small outlined class="mt-1 mb-1" @click="editItem(item)">
        {{ item.showConfirmText }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElTableAction',
  props: {
    item: Object,
  },
  methods: {
    searchItem(item) {
      this.$emit('searchItem', item)
    },
    reloadItem(item) {
      this.$emit('reloadItem', item)
    },
    downloadItem(item) {
      this.$emit('downloadItem', item)
    },
    editItem(item) {
      this.$emit('editItem', item)
    },
    viewItem(item) {
      this.$emit('viewItem', item)
    },
    priskirtiItem(item) {
      this.$emit('priskirtiItem', item)
    },
    cancelPriskirtiItem(item) {
      this.$emit('cancelPriskirtiItem', item)
    },
    viewArchyvasItem(item) {
      this.$emit('viewArchyvasItem', item)
    },
    selectItem(item) {
      this.$emit('selectItem', item)
    },
    duplicateItem(item) {
      this.$emit('duplicateItem', item)
    },
    transferItem(item) {
      this.$emit('transferItem', item)
    },
    deleteItem(item) {
      this.$emit('deleteItem', item)
    },
    restoreItem(item) {
      this.$emit('restoreItem', item)
    },
    resendItem(item) {
      this.$emit('resendItem', item)
    },
    sendKitasItem(item) {
      this.$emit('sendKitasItem', item)
    },
    dvsItem(item) {
      this.$emit('dvsItem', item)
    },
    addAtstovas(item) {
      this.$emit('addAtstovas', item)
    },
    editAtstovas(item) {
      this.$emit('editAtstovas', item)
    },
    viewAtstovas(item) {
      this.$emit('viewAtstovas', item)
    },
    deleteAtstovas(item) {
      this.$emit('deleteAtstovas', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-action {
  line-height: 24px;
}
.table-action:hover {
  color: var(--v-primary-base);
}
.actions div {
  display: inline-flex;
  line-height: 24px;
}
</style>
